import React from 'react';
import InputAdornment from '@mui/material/InputAdornment';
import MaskedTextField from 'core/components/MaskedTextField';
import {
  FieldComponentProps,
  FieldType,
} from 'views/EMR/components/FillableForm/types';
import {
  placeholderByType,
} from 'views/EMR/components/FillableForm/utils/fieldPositioning';

const commonMaskRules = {
  mask: Number,
  min: 0,
  max: 999999999999999,
  scale: 2,
  radix: '.',
  padFractionalZeros: false,
  normalizeZeros: true,
  thousandsSeparator: ',',
  lazy: false,
};

const percentMask = [{
  mask: Number,
  min: 0,
  max: 100,
  radix: '.',
  lazy: false,
}];

const numberMask = [{
  ...commonMaskRules,
  scale: 2,
}];

const integerMask = [{
  ...commonMaskRules,
  scale: 0,
}];

const maskByType: Partial<Record<FieldType, object[]>> = Object.freeze({
  integer: integerMask,
  percent: percentMask,
});

export default function NumberInput({ field, value, onChange }: FieldComponentProps) {
  const { type, format } = field ?? {};
  const mask = maskByType[type] ?? numberMask;
  const isDecimal = /[.]/i.test(format ?? '');
  const placeholder = placeholderByType[type] ?? 'Please enter a number';
  return (
    <MaskedTextField
      unmask
      mask={mask}
      autoFocus
      fullWidth
      value={value?.value ?? ''}
      onAccept={(data: string) => {
        onChange?.({ ...value, value: data });
      }}
      placeholder={isDecimal ? 'Please enter a number (e.g: 123.12)' : placeholder}
      slotProps={type === 'percent' ? {
        input: {
          endAdornment: (
            <InputAdornment position="end">
              %
            </InputAdornment>
          ),
        },
      } : undefined}
    />
  );
}
